<i18n>
{
  "fr": {
    "folderConception": "Dossier de conception",
    "folderNumberOfConnection": "Numéro dossier branchement neuf :",
    "originFolder": "Origine du dossier ",
    "newBuildingPermit": "Nouveau permis de construire",
    "subsidizedWork": "Ouvrage subventionné",
    "zac": "ZAC",
    "compliance" : "Mise en conformité",
    "roadConstruction": "Ouvrage de voirie",
    "numberBuildingLicence": "N° De PC (Permis de Construire) : ",
    "yearBuildingLicence": "Année PC :",
    "remmberSurface": "Rappel de la décomposition des surfaces ",
    "partialSurface": "Surface Parcelle (m²) :",
    "activSurface": "Surface active (m²) :",
    "observation": "Observations :",
    "diffrenceTypeSurface": "Différents types de surfaces ",
    "topsoilInGround": "Espace vert en pleine terre (m²) :",
    "topsoilInSlab": "Terre végétale sur dalle &lt; 40 cm d'épaisseur (m²) :",
    "simpleRoof" :"Toiture imperméable (m²) :",
    "gravelledTerraceRoof": "Toiture gravillonnée (m²) :",
    "otherSurfaceType": "Voiries, allées, parkings,… imperméables (m²) :",
    "disconnectionWaterRain": "Déconnexion des eaux pluviales jusqu'à la pluie décennale prescrite: ",
    "flow": "Débit",
    "work": "Ouvrages",
    "disconnectionTotalRainWater": "Déconnexion totale des eaux pluviales jusqu'à la pluie décennale prescrit",
    "disconnectionPartialRainWater": "Déconnexion partielle des eaux pluviales jusqu'à la pluie décennale prescrit",
    "disconnectionSurface": "Surface déconnectée jusqu'à la pluie décennale (m²):",
    "leakFlow": "Débit de fuite prescrit (en L/s) :",
    "rateVolume": "Volume prescrit (m³) : ",
    "type": "Type :",
    "regulationWork": "Régulation :",
    "numberWork": "Nombre :",
    "activeSurface": "Surface active raccordée à l'ouvrage :",
    "surface": "Surface raccordée à l'ouvrage :",
    "workNumber": "Ouvrage - N°{number}",
    "debit": "Débit prescrit :",
    "volume": "Volume prescrit :",
    "prescribedLeakageRate": "Débit de fuite prescrit (en L/s) :",
    "prescribedVolume": "Volume prescrit (m³) :",
    "extensiveGreenRoofThick": "Toiture végétalisée extensive (5-15 cm d'épaisseur) (m²) :",
    "semiIntensiveGreenRoofThick": "Toiture végétalisée semi-intensive (15-40 cm d'épaisseur) (m²) :",
    "intensiveRoofingThick": "Toiture intensive (40 cm à 1m d'épaisseur) (m²) :",
    "semiPermeableCoating": "Revêtement semi-perméable (m²) :",
    "topsoilOnSlabThickness": "Terre végétale sur dalle > 40 cm d'épaisseur (m²) :",
    "areaNotCollectedOrSelfManaged": "Surface non collectée ou auto-gérée (espace pleine terre ; substrat > 80 cm d'épaisseur ou toiture régulée) (m²) :"
    }
}
</i18n>

<template>
  <div id="conception-data" class="block mg-0">
    <template v-if="property.conception">
      <Content :title="this.$i18n.t('folderConception')">
        <span slot="main-text-1">
          <h4>{{ $t('originFolder') }}</h4>
          <p class="text">
            <template v-if="property.conception.newBuildingPermit">
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('newBuildingPermit') }}
          </p>
          <p class="text">
            <template v-if="property.conception.subsidizedWork">
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('subsidizedWork') }}
          </p>
          <p class="text">
            <template v-if="property.conception.compliance">
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('compliance') }}
          </p>
          <p class="text">
            <template v-if="property.conception.zac">
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('zac') }}
          </p>
          <p class="text">
            <template v-if="property.conception.roadConstruction">
              <v-icon name="check" />
            </template>
            <template v-else>
              <v-icon name="times" class="nok" />
            </template>
            {{ $t('roadConstruction') }}
          </p>
        </span>
        <span slot="main-text-2">
          <p class="text">
            {{ $t('folderNumberOfConnection') }}
            <span>{{ property.conception.folderNumberOfConnection }}</span>
          </p>
          <p class="text">
            {{ $t('numberBuildingLicence') }}
            <span>{{ property.conception.numberBuldingPermit }}</span>
          </p>
          <p class="text">
            {{ $t('yearBuildingLicence') }}
            <span>{{ property.conception.yearBulidingPermit }}</span>
          </p>
        </span>
      </Content>
      <Content :title="this.$i18n.t('remmberSurface')">
        <span slot="main-text-1">
          <p class="text">
            {{ $t('partialSurface') }}
            <span v-if="![null, ''].includes(property.conception.plotSurface)">
              {{ `${new Intl.NumberFormat().format(property.conception.plotSurface)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('activSurface') }}
            <span v-if="![null, ''].includes(property.conception.activeSurface)">
              {{ `${new Intl.NumberFormat().format(property.conception.activeSurface)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('observation') }}
            <span>{{ property.conception.observations }}</span>
          </p>
          <p class="text">
            {{ $t('disconnectionWaterRain') }}
            <span>{{ getValuePluviaal(property.conception.disconnectionOfRainwater) }}</span>
          </p>

          <p class="text">
            {{ $t('disconnectionSurface') }}
            <span v-if="![null, ''].includes(property.conception.surfaceDisconnect)">
              {{ `${new Intl.NumberFormat().format(property.conception.surfaceDisconnect)}` }}
            </span>
          </p>

          <p class="text">
            {{ $t('prescribedLeakageRate') }}
            <span v-if="![null, ''].includes(property.conception.leakFlowRate)">
              {{ `${new Intl.NumberFormat().format(property.conception.leakFlowRate)}` }}
            </span>
          </p>

          <p class="text">
            {{ $t('prescribedVolume') }}
            <span v-if="![null, ''].includes(property.conception.rateVolume)">
              {{ `${new Intl.NumberFormat().format(property.conception.rateVolume)}` }}
            </span>
          </p>
        </span>
        <span slot="main-text-2">
          <h4 class="mg-l-8">{{ $t('diffrenceTypeSurface') }}</h4>
          <p class="text">
            {{ $t('otherSurfaceType') }}
            <span v-if="![null, ''].includes(property.conception.otherSurfaceType)">
              {{ `${new Intl.NumberFormat().format(property.conception.otherSurfaceType)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('simpleRoof') }}
            <span v-if="![null, ''].includes(property.conception.simpleRoof)">
              {{ `${new Intl.NumberFormat().format(property.conception.simpleRoof)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('gravelledTerraceRoof') }}
            <span v-if="![null, ''].includes(property.conception.gravelledTerraceRoof)">
              {{ `${new Intl.NumberFormat().format(property.conception.gravelledTerraceRoof)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('extensiveGreenRoofThick') }}
            <span v-if="![null, ''].includes(property.conception.extensiveGreenRoofThick)">
              {{ `${new Intl.NumberFormat().format(property.conception.extensiveGreenRoofThick)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('semiIntensiveGreenRoofThick') }}
            <span v-if="![null, ''].includes(property.conception.semiIntensiveGreenRoofThick)">
              {{ `${new Intl.NumberFormat().format(property.conception.semiIntensiveGreenRoofThick)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('intensiveRoofingThick') }}
            <span v-if="![null, ''].includes(property.conception.intensiveRoofingThick)">
              {{ `${new Intl.NumberFormat().format(property.conception.intensiveRoofingThick)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('semiPermeableCoating') }}
            <span v-if="![null, ''].includes(property.conception.semiPermeableCoating)">
              {{ `${new Intl.NumberFormat().format(property.conception.semiPermeableCoating)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('topsoilInSlab') }}
            <span v-if="![null, ''].includes(property.conception.topsoilInSlab)">
              {{ `${new Intl.NumberFormat().format(property.conception.topsoilInSlab)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('topsoilOnSlabThickness') }}
            <span v-if="![null, ''].includes(property.conception.topsoilOnSlabThickness)">
              {{ `${new Intl.NumberFormat().format(property.conception.topsoilOnSlabThickness)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('topsoilInGround') }}
            <span v-if="![null, ''].includes(property.conception.topsoilInGround)">
              {{ `${new Intl.NumberFormat().format(property.conception.topsoilInGround)}` }}
            </span>
          </p>
          <p class="text">
            {{ $t('areaNotCollectedOrSelfManaged') }}
            <span v-if="![null, ''].includes(property.conception.areaNotCollectedOrSelfManaged)">
              {{ `${new Intl.NumberFormat().format(property.conception.areaNotCollectedOrSelfManaged)}` }}
            </span>
          </p>
        </span>
      </Content>
      <template v-if="property.conception.works.length > 0">
        <Content :title="this.$i18n.t('work')" :multiple="true">
          <b-col md="4" sm="6" class="block-work" v-for="work in property.conception.works" :key="work.workNumber">
            <slot v-bind:work="work">
              <p class="text">{{ $t('workNumber', { number: work.workNumber }) }}</p>
              <hr />
              <p class="text">
                {{ $t('type') }}
                <span>{{ getTypeOfWork(work.typeOfWork) }}</span>
              </p>
              <p class="text">
                {{ $t('regulationWork') }}
                <span>{{ getControlOfWork(work.controlOfWork) }}</span>
              </p>
              <p class="text">
                {{ $t('numberWork') }}
                <span v-if="![null, ''].includes(work.number)">
                  {{ `${new Intl.NumberFormat().format(work.number)}` }}
                </span>
              </p>
              <p class="text">
                {{ $t('activeSurface') }}
                <span v-if="![null, ''].includes(work.activeSurface)">
                  {{ `${new Intl.NumberFormat().format(work.activeSurface)}` }}
                </span>
              </p>
              <p class="text">
                {{ $t('surface') }}
                <span v-if="![null, ''].includes(work.surface)">
                  {{ `${new Intl.NumberFormat().format(work.surface)}` }}
                </span>
              </p>
              <p class="text">
                {{ $t('debit') }}
                <span v-if="![null, ''].includes(work.debit)">
                  {{ `${new Intl.NumberFormat().format(work.debit)}` }}
                </span>
              </p>
              <p class="text">
                {{ $t('volume') }}
                <span v-if="![null, ''].includes(work.volume)">
                  {{ `${new Intl.NumberFormat().format(work.volume)}` }}
                </span>
              </p>
            </slot>
          </b-col>
        </Content>
      </template>
    </template>
  </div>
</template>
<script>
import Content from '../Content';
import { mapState } from 'vuex';

export default {
  name: 'ConceptionData',
  components: {
    Content,
  },
  computed: {
    ...mapState({ property: (state) => state.refProperties.property }),
  },
  methods: {
    getControlOfWork(value) {
      const options = [
        'Pompes',
        'Vortex',
        'Effet siphon',
        'A flotteur',
        'Orifice / Plaque',
        'Crapaudines',
        'Infiltration',
      ];
      return options[value];
    },
    getValuePluviaal(value) {
      let arr = [
        { text: 'Aucune', value: 'none' },
        {
          text: "Déconnexion totale",
          value: 'totalDisconnection',
        },
        {
          text: "Déconnexion partielle",
          value: 'partialDisconnection',
        },
      ];
      let obj = arr.find((p) => p.value === value);
      if (obj) {
        return obj.text;
      } else {
        return 'Aucune';
      }
    },
    getTypeOfWork(value) {
      const options = [
        'Bassin enterré avec casiers',
        "Bassin enterré en nid d'abeille",
        'Bassin enterré visitable',
        'Bassin ouvert en eau',
        'Bassin ouvert sec',
        'Canalisation surdimensionnée',
        'Cuve de réutilisation des eaux de pluies',
        'Noue Minérale',
        'Noue Végétalisée',
        "Puits d'infiltration non visitable",
        "Puits d'infiltration vide",
        "Puits d'infiltration visitable",
        'Toiture terrasse minérale',
        'Toiture végétalisée extensive',
        'Toiture végétalisée intensive',
        'Toiture végétalisée semi-intensive',
        'Tranchée Drainante',
      ];
      return options[value];
    },
  },
};
</script>
